module.exports = __webpack_public_path__ + "img/pet_bostie.dec76492.svg";